import { render, staticRenderFns } from "./StyleDialogStyleTabs.vue?vue&type=template&id=51149245&scoped=true&"
import script from "./StyleDialogStyleTabs.vue?vue&type=script&lang=js&"
export * from "./StyleDialogStyleTabs.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogStyleTabs.vue?vue&type=style&index=0&id=51149245&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51149245",
  null
  
)

export default component.exports